export default "__VITE_ASSET__h9kPwJn___"